import React, { PureComponent } from 'react'
import { find, get } from 'lodash'
import { Select } from "@driftt/tide-core-legacy"

import TeamAvatarList from 'components/settings/team/TeamAvatarList'

import { PARTICIPANT_TYPES } from './constants'

class TeamParticipantAction extends PureComponent {

  constructor(props) {
    super(props)

    const selectedTeamId = get(props.rule, 'data.item.action.options.teamId', null)

    this.state = {
      selectedTeam: !!selectedTeamId
                      ? find(props.teamsOptions, { value: { id: selectedTeamId }}) || null
                      : null
    }
  }

  onTeamSelected = (selectedOption) => {
    const { setActionParticipants } = this.props

    this.setState({ selectedTeam: selectedOption },
      () => {
        const participants = this.state.selectedTeam ? [this.state.selectedTeam.value.id] : []
        setActionParticipants({ participants: participants, participantType: PARTICIPANT_TYPES.TEAM})
      }
    )
  }

  render() {
    const { teamsOptions } = this.props
    const { selectedTeam } = this.state

    return (
      <div className="participant-action team-participant">
        <div className="participant-action-selector-description">Who do you want to add to the group?</div>
        <Select
          autoFocus={true}
          options={teamsOptions}
          pageSize={10}
          placeholder='Pick a Team...'
          onChange={this.onTeamSelected}
          value={selectedTeam}
        />
        { !!selectedTeam && <TeamAvatarList teamId={selectedTeam.value.id}/>}
      </div>
    )
  }

}

export default TeamParticipantAction


// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/ActionEditor/ParticipantActions/TeamParticipantAction.js